import { render, staticRenderFns } from "./NewEventRegistration.vue?vue&type=template&id=120c0d44&scoped=true&"
import script from "./NewEventRegistration.vue?vue&type=script&lang=js&"
export * from "./NewEventRegistration.vue?vue&type=script&lang=js&"
import style0 from "./NewEventRegistration.vue?vue&type=style&index=0&id=120c0d44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120c0d44",
  null
  
)

export default component.exports